import React from 'react';

import { useTranslation } from '@lyearn/i18n';
import { Shuffle } from '@lyearn/icons';
import { cn } from '@lyearn/style';
import { Box, Stack, Typography } from '@lyearn/ui';

import { randomCardStyles } from '../styles';

const RandomCard: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Box
      className={cn(
        'h-full w-full cursor-pointer rounded-8 border border-border-dark',
        randomCardStyles,
      )}>
      <Stack alignItems="center" className="h-full w-full" direction="col" justifyContent="center">
        <Shuffle className="mb-12 h-24 w-24 fill-current text-icon-white" />
        <Typography color="text-text-white" variant="body-short-03">
          {t('Common:Random')}
        </Typography>
      </Stack>
    </Box>
  );
};

export default RandomCard;
